import type {PayloadAction} from '@reduxjs/toolkit'
import {createSlice} from '@reduxjs/toolkit'

// Only one panel can be open at a time; null means all closed
export type SidePanelKey =
  | 'velocity'
  | 'onTimeDelivery'
  | 'defectAgeing'
  | 'onTimeDeliveryTeam'
  | 'defectDensityTeam'
  | 'iterationSummaryTeam'
  | 'testAutomation'
  | 'overallAutomationCoverage'
  | 'manualTestPlanTrend'
  | 'qaMetricsBugsPerEnvironment'
  | 'teamBuildDetails'
  | 'teamCodeRepo'
  | 'updateKPIs'
  | 'detailsSidePanel'
  | 'editStatusSidePanel'
  | 'aiMetricsDetailsSidePanel'
  | 'inactiveUsersSidePanel'
  | 'teamUsageDetailsSidePanel'
  | 'editDetailsSidePanel'
  | 'widgetPanel_build'
  | 'widgetPanel_deploy'
  | 'widgetPanel_repo'
  | 'widgetPanel_securityanalysis'
  | 'widgetPanel_codeanalysis'
  | 'widgetPanel_qa'
  | 'widgetPanel_feature'
  | null
interface SidePanelState {
  openPanel: SidePanelKey
  selectedProgram: any // Store the selected program/row data
}

const initialState: SidePanelState = {
  openPanel: null,
  selectedProgram: null,
}

const sidePanelSlice = createSlice({
  name: 'sidePanel',
  initialState,
  reducers: {
    openPanel: (state, action: PayloadAction<SidePanelKey>) => {
      state.openPanel = action.payload
    },
    closePanel: state => {
      state.openPanel = null
    },
    setSelectedProgram: (state, action: PayloadAction<any>) => {
      state.selectedProgram = action.payload
    },
  },
})

export const {openPanel, closePanel, setSelectedProgram} = sidePanelSlice.actions
export default sidePanelSlice.reducer
